import { render } from "./layoutPrincipal.vue?vue&type=template&id=517272ce&scoped=true"
import script from "./layoutPrincipal.vue?vue&type=script&lang=js"
export * from "./layoutPrincipal.vue?vue&type=script&lang=js"

import "./layoutPrincipal.vue?vue&type=style&index=0&id=517272ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-517272ce"]])

export default __exports__